<template>
    <div class="tell-us-wrapper">
        <div class="declarative-wrapper" v-if="declarativeData && !isCompleted">
            <div class="declarative-title">{{ $t('wallet051') }}</div>
            <div class="declarative-subtitle">{{ $t('wallet059') }}</div>

            <h5>{{ $t('wallet053') }}</h5>
            <v-row style="width:100%;">
                <v-col>
                    <v-text-field :label="$t('wallet056')" v-model="declarativeData.firstName" outlined></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field :label="$t('wallet057')" v-model="declarativeData.lastName" outlined></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field label="Email" v-model="declarativeData.email" disabled outlined></v-text-field>
                </v-col>
            </v-row>
            <v-row style="width:100%;" class="declarative-select-wrapper">
                <v-col>
                    <v-flex style="position: relative;">
                        <span>{{ $t('myprofile6') }}</span>
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                            :rules="[rules.required]"
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    v-model="dateOfBirth"
                                    readonly
                                    v-on="on"
                                    :rules="[rules.required]"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="declarativeData.dateOfBirth" no-title scrollable
                                           :rules="[rules.required]">
                                <div class="flex-grow-1"></div>
                                <v-btn text color="primary" @click="menu = false">{{ $t('cancel') }}</v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(declarativeData.dateOfBirth)">OK
                                </v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-flex>
                </v-col>
                <v-col>
                    <v-flex v-if="vin_countries.length" style="position: relative;">
                        <span>{{ $t('wallet054') }}</span>
                        <country-select class="country-select" v-model="nationality" :whiteList="vin_countries" :country="nationality" />
                    </v-flex>
                </v-col>
                <v-col>
                    <v-flex v-if="vin_countries.length" style="position: relative;">
                        <span>{{ $t('wallet055') }}</span>
                        <country-select class="country-select" v-model="country" :whiteList="vin_countries" :country="country" />
                    </v-flex>
                </v-col>
            </v-row>

            <div class="section-row" v-if="userData.mangopayStatus === 0 || userData.mangopayStatus === 1">
                <i18n path="wallet052" tag="div" class="section-info">
                    <a href="https://mangopay.com/terms-and-conditions/payment-services" target="_blank" place="terms">{{ $t('wallet052-1') }}</a>
                    <a href="https://mangopay.com/privacy-statement" place="privacy">{{ $t('wallet052-2') }}</a>
                </i18n>
                <v-switch
                    v-model="mangopayTerms"
                    hide-details
                    color="primary"
                    class="section-switch"
                ></v-switch>
            </div>

            <v-btn class="declarative-btn" v-on:click="updateDeclarativeData" :disabled="disableButton">{{ $t('continue') }}</v-btn>
        </div>
        <div class="completed-wrapper" v-if="isCompleted">
            <div class="completed-content">
                <svg xmlns="http://www.w3.org/2000/svg" width="201" height="200" viewBox="0 0 201 200" fill="none">
                    <path d="M41.125 30C41.125 27.2386 43.3636 25 46.125 25H128.625L159.875 56.25V170C159.875 172.761 157.636 175 154.875 175H46.125C43.3636 175 41.125 172.761 41.125 170V30Z" fill="#004F7F"/>
                    <path d="M159.875 56.25H131.625C129.968 56.25 128.625 54.9069 128.625 53.25V25L159.875 56.25Z" fill="#B3CAD9"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M100 79.1564L84.4883 134.603C85.5834 136.096 86.806 137.525 88.1561 138.875C89.7815 140.501 91.5218 141.942 93.3507 143.198L112.033 76.4199C107.929 76.6448 103.856 77.5569 100 79.1564ZM117.633 76.5396L98.199 146.004C99.8499 146.796 101.548 147.458 103.277 147.988L123.006 77.4714C121.236 77.0269 119.44 76.7163 117.633 76.5396Z" fill="white"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M144.481 139.562C158.185 123.601 157.477 99.5242 142.355 84.4027C126.49 68.5376 100.768 68.5376 84.9027 84.4027C69.0376 100.268 69.0376 125.99 84.9027 141.855C100.024 156.977 124.101 157.685 140.062 143.981L144.942 148.862C143.278 152.346 143.888 156.646 146.775 159.533L168.872 181.63C172.533 185.291 178.469 185.291 182.13 181.63C185.791 177.969 185.791 172.033 182.13 168.372L160.033 146.274C157.147 143.388 152.846 142.777 149.362 144.442L144.481 139.562ZM135.726 135.226C147.93 123.022 147.93 103.236 135.726 91.0318C123.522 78.8279 103.736 78.8279 91.5318 91.0318C79.3279 103.236 79.3279 123.022 91.5318 135.226C103.736 147.43 123.522 147.43 135.726 135.226Z" fill="#B3CAD9"/>
                </svg>
                <div class="completed-text">{{ $t('wallet003') }}</br>{{ $t('wallet004') }}</div>
                <div class="completed-info">{{ $t('wallet005') }}</div>
                <div class="completed-info2">{{ $t('wallet006') }}</div>
            </div>
            <nuxt-link class="continue-upload-btn" @click.native="goToWallet()" :to="localePath('/my-account')">OK</nuxt-link>
        </div>

        <v-dialog v-model="showDeclarativeData" persistent max-width="570px" content-class="verify-modal-wrapper">
            <v-card class="verify-modal">
                <div class="step-wrapper" v-if="step === 1">
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title">{{ $t('wallet037') }}</div>
                    <div class="verify-modal-subtitle">{{ $t('wallet038') }}</div>

                    <div class="subtitle-wrapper">
                        <div class="subtitle-wrapper-text">{{ $t('wallet039') }}</div>
                    </div>

                    <div v-if="vin_countries.length" class="doc-country-wrapper">
                        <country-select class="country-select" v-model="docCountry" :whiteList="vin_countries" :country="docCountry" />
                    </div>

                    <div class="subtitle-wrapper">
                        <div class="subtitle-wrapper-text">{{ $t('wallet040') }}</div>
                    </div>
                    <div class="doc-wrapper" v-if="documentByCountry(1)" v-on:click="() => {showNextStep(1)}">
                        <div class="doc-wrapper-img"></div>
                        <div class="doc-wrapper-texts">
                            <div class="doc-wrapper-text">{{ $t('wallet041') }}</div>
                            <div class="doc-wrapper-info">{{ $t('wallet042') }}</div>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M10.7052 6.70538C10.3157 6.31581 9.68403 6.31581 9.29446 6.70538C8.90519 7.09466 8.90484 7.72569 9.29369 8.11538L13.1698 12L9.29369 15.8846C8.90484 16.2743 8.90519 16.9053 9.29446 17.2946C9.68403 17.6842 10.3157 17.6842 10.7052 17.2946L15.2927 12.7071C15.6833 12.3166 15.6833 11.6834 15.2927 11.2929L10.7052 6.70538Z" fill="#004F7F"/>
                        </svg>
                    </div>
                    <div class="doc-wrapper" v-if="documentByCountry(2)" v-on:click="() => {showNextStep(2)}">
                        <div class="doc-wrapper-img2"></div>
                        <div class="doc-wrapper-texts">
                            <div class="doc-wrapper-text">{{ $t('wallet043') }}</div>
                            <div class="doc-wrapper-info">{{ $t('wallet044') }}</div>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M10.7052 6.70538C10.3157 6.31581 9.68403 6.31581 9.29446 6.70538C8.90519 7.09466 8.90484 7.72569 9.29369 8.11538L13.1698 12L9.29369 15.8846C8.90484 16.2743 8.90519 16.9053 9.29446 17.2946C9.68403 17.6842 10.3157 17.6842 10.7052 17.2946L15.2927 12.7071C15.6833 12.3166 15.6833 11.6834 15.2927 11.2929L10.7052 6.70538Z" fill="#004F7F"/>
                        </svg>
                    </div>
                    <div class="doc-wrapper" v-if="documentByCountry(3)" v-on:click="() => {showNextStep(3)}">
                        <div class="doc-wrapper-img3"></div>
                        <div class="doc-wrapper-texts">
                            <div class="doc-wrapper-text">{{ $t('wallet045') }}</div>
                            <div class="doc-wrapper-info">{{ $t('wallet044') }}</div>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M10.7052 6.70538C10.3157 6.31581 9.68403 6.31581 9.29446 6.70538C8.90519 7.09466 8.90484 7.72569 9.29369 8.11538L13.1698 12L9.29369 15.8846C8.90484 16.2743 8.90519 16.9053 9.29446 17.2946C9.68403 17.6842 10.3157 17.6842 10.7052 17.2946L15.2927 12.7071C15.6833 12.3166 15.6833 11.6834 15.2927 11.2929L10.7052 6.70538Z" fill="#004F7F"/>
                        </svg>
                    </div>
                    <div class="doc-wrapper" v-if="documentByCountry(4)" v-on:click="() => {showNextStep(4)}">
                        <div class="doc-wrapper-img4"></div>
                        <div class="doc-wrapper-texts">
                            <div class="doc-wrapper-text">{{ $t('wallet046') }}</div>
                            <div class="doc-wrapper-info">{{ $t('wallet044') }}</div>
                        </div>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M10.7052 6.70538C10.3157 6.31581 9.68403 6.31581 9.29446 6.70538C8.90519 7.09466 8.90484 7.72569 9.29369 8.11538L13.1698 12L9.29369 15.8846C8.90484 16.2743 8.90519 16.9053 9.29446 17.2946C9.68403 17.6842 10.3157 17.6842 10.7052 17.2946L15.2927 12.7071C15.6833 12.3166 15.6833 11.6834 15.2927 11.2929L10.7052 6.70538Z" fill="#004F7F"/>
                        </svg>
                    </div>
                </div>
                <div class="step-wrapper" v-if="step === 2">
                    <div class="back-modal-btn" v-on:click="() => { uploadOrTake = null; step = 1; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title" v-if="documnetId === 1">{{ $t('wallet082-1') }}</div>
                    <div class="verify-modal-title" v-if="documnetId === 2">{{ $t('wallet082-2') }}</div>
                    <div class="verify-modal-title" v-if="documnetId === 3">{{ $t('wallet082') }}</div>
                    <div class="verify-modal-title" v-if="documnetId === 4">{{ $t('wallet082-3') }}</div>

                    <div class="upload-selection-wrapper">
                        <v-radio-group class="upload-selection--radio" v-model="uploadOrTake">
                            <div class="doc-wrapper doc-wrapper2" v-on:click="() => {uploadOrTake = true}">
                                <div class="doc-wrapper-texts">
                                    <div class="doc-wrapper-text">{{ $t('wallet083') }}</div>
                                    <div class="doc-wrapper-info">{{ $t('wallet084') }}</div>
                                </div>
                                <v-radio :value=true></v-radio>
                            </div>
                            <div class="doc-wrapper doc-wrapper2" v-on:click="() => {uploadOrTake = false}">
                                <div class="doc-wrapper-texts">
                                    <div class="doc-wrapper-text">{{ $t('wallet085') }}</div>
                                </div>
                                <v-radio :value=false></v-radio>
                            </div>
                        </v-radio-group>
                    </div>

                    <v-btn text class="continue-upload-btn" :disabled="uploadOrTake === null" v-on:click="() => { step = 3; }">Continue</v-btn>
                </div>
                <div class="step-wrapper" v-if="step === 3">
                    <div class="back-modal-btn" v-on:click="() => { step = 2; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title" v-if="documnetId === 1">{{ $t('wallet103') }}</div>
                    <div class="verify-modal-title" v-if="documnetId === 2">{{ $t('wallet104') }}</div>
                    <div class="verify-modal-title" v-if="documnetId === 3">{{ $t('wallet099') }}</div>
                    <div class="verify-modal-title" v-if="documnetId === 4">{{ $t('wallet105') }}</div>
                    <div class="verify-modal-subtitle">{{ $t('wallet023') }}</div>
                    <div class="verify-modal-subtitle2">{{ $t('wallet024') }}</div>
                    <div class="example-id1"></div>

                    <div class="upload-info">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9286 4.14286C11.3603 4.14286 10.8152 4.36862 10.4133 4.77049C10.0115 5.17235 9.78571 5.71739 9.78571 6.28571V8.42857H14.0714V6.28571C14.0714 5.71739 13.8457 5.17235 13.4438 4.77049C13.0419 4.36862 12.4969 4.14286 11.9286 4.14286ZM7.64286 6.28571V8.42857H4.78571C3.79949 8.42857 3 9.22806 3 10.2143V20.2143C3 21.2005 3.79949 22 4.78571 22H19.0714C20.0577 22 20.8571 21.2005 20.8571 20.2143V10.2143C20.8571 9.22806 20.0577 8.42857 19.0714 8.42857H16.2143V6.28571C16.2143 5.14907 15.7628 4.05898 14.959 3.25526C14.1553 2.45153 13.0652 2 11.9286 2C10.7919 2 9.70184 2.45153 8.89811 3.25526C8.09439 4.05898 7.64286 5.14907 7.64286 6.28571ZM5.14286 10.5714H8.71429H15.1429H18.7143V19.8571H5.14286V10.5714ZM13.3571 15.2143C13.3571 16.0033 12.7176 16.6429 11.9286 16.6429C11.1396 16.6429 10.5 16.0033 10.5 15.2143C10.5 14.4253 11.1396 13.7857 11.9286 13.7857C12.7176 13.7857 13.3571 14.4253 13.3571 15.2143Z" fill="#04010D" fill-opacity="0.6"/>
                        </svg>
                        <div class="upload-info-text">{{ $t('wallet025') }}</div>
                    </div>
                    <v-btn text class="continue-upload-btn" v-on:click="() => { step = 4; }">Continue</v-btn>
                </div>
                <div class="step-wrapper" v-if="step === 4">
                    <div class="back-modal-btn" v-on:click="() => { step = 3; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title">{{ $t('wallet026') }}</div>
                    <div class="verify-modal-subtitle">{{ $t('wallet027') }}</div>

                    <div class="example-id2"></div>
                    <div class="example-id3-wrapper">
                        <div class="example-id3"></div>
                        <div class="example-id4"></div>
                    </div>
                    <div class="example-id3-wrapper">
                        <div class="example-id5"></div>
                        <div class="example-id6"></div>
                    </div>

                    <v-btn text class="continue-upload-btn" v-on:click="goToUploadOrTakeStep">{{ $t('continue') }}</v-btn>
                </div>
                <div class="step-wrapper" v-if="step === 5 && uploadOrTake">
                    <div class="back-modal-btn" v-on:click="() => { step = 4; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title">{{ $t('wallet068') }}</div>
                    <div class="verify-modal-subtitle">{{ $t('wallet069') }}</div>

                    <div
                        :class="isDragging ? 'dropzone-container-dragging' : 'dropzone-container'"
                        @dragover="dragover"
                        @dragleave="dragleave"
                        @drop="drop"
                    >
                        <input
                            type="file"
                            name="file"
                            id="fileInput"
                            class="hidden-input"
                            @change="onChange"
                            ref="file"
                            accept=".pdf,.jpg,.jpeg,.png"
                        />

                        <label v-if="!files.length" for="fileInput" class="file-label">
                            <div v-if="isDragging" class="upload-file-title">Release to drop the document here</div>
                            <div v-else style="flex-direction: column; display: flex;">
                                <span class="upload-file-title">{{ $t('wallet106') }} <u>{{ $t('wallet107') }}</u> {{ $t('wallet106-1') }}</span>
                                <span class="upload-file-text">{{ $t('wallet071') }}</span>
                            </div>
                        </label>
                        <div v-if="files.length" class="preview-card">
                            <img class="preview-img" :src="generateURL(files[0])" />
                        </div>
                    </div>

                    <v-btn :disabled="disableUploadDocBtn" text class="continue-upload-btn" v-on:click="uploadFirstDoc">{{ $t('continue') }}</v-btn>
                </div>
                <div class="step-wrapper" v-if="step === 5 && !uploadOrTake">
                    <div class="back-modal-btn" v-on:click="() => { step = 4; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title">{{ $t('wallet089') }}</div>

                    <div class="camera-wrapper">
                        <div v-if="isCameraOpen" class="camera-box">
                            <video v-show="!isPhotoTaken" ref="camera" :width="480" :height="270" autoplay></video>
                            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="480" :height="270"></canvas>
                        </div>
                        <div class="camera-wrapper-info">
                            <div class="camera-wrapper-info-text">{{ $t('wallet090') }}</div>
                        </div>
                    </div>

                    <v-btn v-if="!isPhotoTaken" text class="continue-upload-btn" v-on:click="takePhoto">{{ $t('wallet093') }}</v-btn>
                    <div v-if="isPhotoTaken" class="btn-wrapper">
                        <v-btn text class="retake-btn" v-on:click="takePhoto">{{ $t('wallet067') }}</v-btn>
                        <v-btn text class="submit-btn" v-on:click="submitPhoto">{{ $t('wallet088') }}</v-btn>
                    </div>
                </div>
                <div class="step-wrapper" v-if="step === 6">
                    <div class="back-modal-btn" v-on:click="() => { step = 5; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title">{{ $t('wallet032') }}</div>
                    <div class="verify-modal-subtitle">{{ $t('wallet033') }}</div>

                    <div class="example-id7"></div>
                    <div class="example-id3-wrapper">
                        <div class="example-id8"></div>
                        <div class="example-id9"></div>
                    </div>
                    <div class="example-id3-wrapper">
                        <div class="example-id10"></div>
                        <div class="example-id11"></div>
                    </div>

                    <v-btn text class="continue-upload-btn" v-on:click="goToUploadOrTakeStep2">{{ $t('continue') }}</v-btn>
                </div>
                <div class="step-wrapper" v-if="step === 7 && uploadOrTake">
                    <div class="back-modal-btn" v-on:click="() => { step = 6; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title">{{ $t('wallet086') }}</div>
                    <div class="verify-modal-subtitle">{{ $t('wallet087') }}</div>

                    <div
                        :class="isDragging ? 'dropzone-container-dragging' : 'dropzone-container'"
                        @dragover="dragover"
                        @dragleave="dragleave"
                        @drop="drop2"
                    >
                        <input
                            type="file"
                            name="file2"
                            id="fileInput2"
                            class="hidden-input"
                            @change="onChange2"
                            ref="file2"
                            accept=".pdf,.jpg,.jpeg,.png"
                        />

                        <label v-if="!files2.length" for="fileInput2" class="file-label">
                            <div v-if="isDragging" class="upload-file-title">Release to drop the document here</div>
                            <div v-else style="flex-direction: column; display: flex;">
                                <span class="upload-file-title">{{ $t('wallet106') }} <u>{{ $t('wallet107') }}</u> {{ $t('wallet106-1') }}</span>
                                <span class="upload-file-text">{{ $t('wallet071') }}</span>
                            </div>
                        </label>
                        <div v-if="files2.length" class="preview-card">
                            <img class="preview-img" :src="generateURL(files2[0])" />
                        </div>
                    </div>

                    <v-btn :disabled="disableUploadDocBtn2" text class="continue-upload-btn" v-on:click="uploadSecondDoc">{{ $t('continue') }}</v-btn>
                </div>
                <div class="step-wrapper" v-if="step === 7 && !uploadOrTake">
                    <div class="back-modal-btn" v-on:click="() => { step = 6; }">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="ui_left_arrow">
                                <path id="Vector" d="M13.8846 6.70538C14.2742 6.31581 14.9058 6.31581 15.2954 6.70538C15.6847 7.09466 15.685 7.72569 15.2962 8.11538L11.42 12L15.2962 15.8846C15.685 16.2743 15.6847 16.9053 15.2954 17.2946C14.9058 17.6842 14.2742 17.6842 13.8846 17.2946L9.29711 12.7071C8.90658 12.3166 8.90658 11.6834 9.29711 11.2929L13.8846 6.70538Z" fill="black"/>
                            </g>
                        </svg>
                    </div>
                    <div class="close-btn" v-on:click="() => { showDeclarativeData = false; step = 1; }">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6897 6.34443C18.1007 6.73815 18.1007 7.39508 17.6897 7.7888L13.2927 12.0002L17.6897 16.2116C18.1007 16.6053 18.1007 17.2623 17.6897 17.656L17.6201 17.7226C17.2337 18.0927 16.6243 18.0931 16.2375 17.7234L11.999 13.6726L7.76047 17.7234C7.37362 18.0931 6.76429 18.0927 6.37785 17.7226L6.3083 17.656C5.89723 17.2623 5.89723 16.6053 6.3083 16.2116L10.7053 12.0002L6.30832 7.7888C5.89726 7.39508 5.89726 6.73815 6.30832 6.34443L6.37787 6.27782C6.76431 5.90769 7.37364 5.90735 7.76049 6.27707L11.999 10.3279L16.2375 6.27707C16.6244 5.90735 17.2337 5.90769 17.6201 6.27782L17.6897 6.34443Z" fill="black" fill-opacity="0.64"/>
                        </svg>
                    </div>

                    <div class="verify-modal-title">{{ $t('wallet091') }}</div>

                    <div class="camera-wrapper">
                        <div v-if="isCameraOpen" class="camera-box">
                            <video v-show="!isPhotoTaken" ref="camera" :width="480" :height="270" autoplay></video>
                            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" :width="480" :height="270"></canvas>
                        </div>
                        <div class="camera-wrapper-info">
                            <div class="camera-wrapper-info-text">{{ $t('wallet092') }}</div>
                        </div>
                    </div>

                    <v-btn v-if="!isPhotoTaken" text class="continue-upload-btn" v-on:click="takePhoto">{{ $t('wallet093') }}</v-btn>
                    <div v-if="isPhotoTaken" class="btn-wrapper">
                        <v-btn text class="retake-btn" v-on:click="takePhoto">{{ $t('wallet067') }}</v-btn>
                        <v-btn text class="submit-btn" v-on:click="submitPhoto2">{{ $t('wallet088') }}</v-btn>
                    </div>
                </div>
            </v-card>
        </v-dialog>

        <v-dialog v-model="confirmAddressModal" max-width="500px" persistent>
            <v-card class="bids-offers-modal confirm-address-modal">
                <v-card-title>{{ $t('confirm-address05') }}</v-card-title>
                <v-card-text class="cancel-bid-body">
                    {{ $t('confirm-address06') }}
                </v-card-text>
                <v-card-actions>
                    <v-btn class="btn-primary btn-bid-close" text v-on:click="() => { confirmAddressModal = false }">{{ $t('confirm-address03') }}</v-btn>
                    <v-btn class="btn-primary btn-bid-proceed" text v-on:click="updateDeclarativeData">{{ $t('confirm-address04') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import {GUser} from "@/store/getters";
import {AUser} from "@/store/actions";
import moment from "moment";

    export default {
        name: "TellUsMore",
        head: {
            title: 'Tell us more about you | Fine Wine Trading App',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Buy and sell fine wines from your smartphone today! Vindome is the fast, secure and easy way to become a wine trader – right from your smartphone.'
                }
            ],
            bodyAttrs: {
                class: 'how-it-works trading-desk inner-page'
            }
        },
        data() {
            return {
                isCameraOpen: false,
                isPhotoTaken: false,
                isShotPhoto: false,
                confirmAddressModal: false,
                isLoading: false,
                link: '#',
                isDragging: false,
                files: [],
                files2: [],
                isBrowser: false,
                isCompleted: false,
                uploadOrTake: null,
                rules: {
                    required: value => !!value || 'Required.'
                },
                menu: false,
                country: null,
                docCountry: null,
                countryMap: [],
                vin_countries: [],
                mangopayTerms: false,
                showDeclarativeData: false,
                nationality: null,
                step: 1,
                documnetId: 1,
            }
        },
        computed: {
            ...mapState({
                countries: state => state.countries
            }),
            ...mapGetters({
                userData: GUser.GET_USER_DATA,
                declarativeData: GUser.GET_DECLARATIVE_DATA
            }),
            disableUploadDocBtn() {
                return this.files.length === 0
            },
            disableUploadDocBtn2() {
                return this.files2.length === 0
            },
            disableButton() {
                if (this.userData.mangopayStatus === 0 || this.userData.mangopayStatus === 1) {
                    return !this.mangopayTerms
                } else {
                    return false
                }
            },
            dateOfBirth() {
                if (typeof this.declarativeData.countryId !== 'undefined' && this.declarativeData.countryId !== null) {
                    let myProfileCtrl = this;
                    for (let key in this.countries) {
                        if (this.countries.hasOwnProperty(key)) {
                            if (this.countries[key].id === this.declarativeData.countryId.toString()) {
                                myProfileCtrl.country = key;
                                myProfileCtrl.docCountry = key;
                                break;
                            }
                        }
                    }
                }
                if (typeof this.declarativeData.nationalityId !== 'undefined' && this.declarativeData.nationalityId !== null) {
                    let myProfileCtrl = this;
                    for (let key in this.countries) {
                        if (this.countries.hasOwnProperty(key)) {
                            if (this.countries[key].id === this.declarativeData.nationalityId.toString()) {
                                myProfileCtrl.nationality = key;
                                break;
                            }
                        }
                    }
                }
                return this.declarativeData.dateOfBirth === null ? '' : moment(this.declarativeData.dateOfBirth).locale(this.$i18n.locale).format('DD MMM YYYY')
            },
        },
        methods: {
            countryInEEA(country) {
                return ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'DE', 'HU', 'IT', 'IE', 'LT', 'LU', 'LV', 'LI', 'NL', 'MT', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES'].indexOf(country) > -1
            },
            documentByCountry(docId) {
                if (docId === 1 ) {
                    return true
                } else if (docId === 2) {
                    if (this.docCountry === 'ID' || this.docCountry === 'FR' || this.docCountry === 'GR' || this.docCountry === 'NO' || this.docCountry === 'SE' || this.docCountry === 'GB' || this.docCountry === 'CA' || this.docCountry === 'US' || this.docCountry === 'AU' || this.countryInEEA(this.docCountry)) {
                        return true
                    } else {
                        return false
                    }
                } else if (docId === 3) {
                    if (this.docCountry === 'ID' || this.docCountry === 'FR' || this.docCountry === 'GR' || this.docCountry === 'NO' || this.docCountry === 'SE' || this.docCountry === 'CA' || this.docCountry === 'US' || this.docCountry === 'AU' || this.countryInEEA(this.docCountry)) {
                        return true
                    } else {
                        return false
                    }
                } else {
                    if (this.docCountry === 'ID' || this.docCountry === 'FR' || this.docCountry === 'GR' || this.docCountry === 'SE' || this.docCountry === 'CH' || this.countryInEEA(this.docCountry)) {
                        return true
                    } else {
                        return false
                    }
                }
            },
            generateURL(file) {
                let fileSrc = URL.createObjectURL(file);

                setTimeout(() => {
                    URL.revokeObjectURL(fileSrc);
                }, 1000);

                return fileSrc;
            },
            updateDeclarativeData() {
                let _ctrl = this;
                let _payload = Object.assign({}, this.declarativeData)

                _payload.countryId = this.countries[this.country].id;
                _payload.nationalityId = this.countries[this.nationality].id;

                this.$store.dispatch(AUser.UPDATE_DECLARATIVE_DATA, _payload).then((res) => {
                    if (res.scaRedirectUrl) {
                        window.location.href = res.scaRedirectUrl.replace('www.vindome.net', 'vindome.net' + encodeURIComponent(window.location.pathname + window.location.search))
                    } else {
                        _ctrl.$store.dispatch(AUser.GET_USER_DATA).then(() => {
                            _ctrl.confirmAddressModal = false
                            _ctrl.showDeclarativeData = true
                        })
                    }
                }).catch((err) => {
                    const message = err?.message || err?.data?.message || (typeof err === 'string' ? err : 'Something went wrong. Please try again.')
                    alert(message)
                })
            },
            showNextStep(docId) {
                this.step = 2;
                this.documnetId = docId
            },
            goToWallet() {
                this.$nuxt.$emit("goToSection", "wallet");
            },
            onChange() {
                this.files = this.$refs.file.files;
            },
            onChange2() {
                this.files2 = this.$refs.file2.files;
            },
            dragover(e) {
                e.preventDefault();
                this.isDragging = true;
            },
            dragleave() {
                this.isDragging = false;
            },
            drop(e) {
                e.preventDefault();
                this.$refs.file.files = e.dataTransfer.files;
                this.onChange();
                this.isDragging = false;
            },
            drop2(e) {
                e.preventDefault();
                this.$refs.file2.files = e.dataTransfer.files;
                this.onChange2();
                this.isDragging = false;
            },
            uploadFirstDoc() {
                let _ctrl = this;
                const files = this.files;
                const formData = new FormData();

                files.forEach((file) => {
                    formData.append("file", file);
                });

                this.$store.dispatch(AUser.UPLOAD_DOCUMENT_ONE, formData).then((res) => {
                    if (res.succeeded) {
                        if (_ctrl.documnetId === 1) {
                            _ctrl.isCompleted = true
                            _ctrl.showDeclarativeData = false
                            _ctrl.$store.dispatch(AUser.UPLOAD_DOCUMENT_SUBMIT);
                        } else {
                            _ctrl.step = 6
                        }
                    }
                })
            },
            uploadSecondDoc() {
                let _ctrl = this;
                const files = this.files2;
                const formData = new FormData();

                files.forEach((file) => {
                    formData.append("file", file);
                });

                this.$store.dispatch(AUser.UPLOAD_DOCUMENT_TWO, formData).then((res) => {
                    if (res.succeeded) {
                        _ctrl.isCompleted = true
                        _ctrl.showDeclarativeData = false
                        _ctrl.$store.dispatch(AUser.UPLOAD_DOCUMENT_SUBMIT);
                    }
                })
            },
            goToUploadOrTakeStep() {
                if (!this.uploadOrTake) {
                    this.isCameraOpen = true;
                    this.createCameraElement();
                }

                this.step = 5
            },
            goToUploadOrTakeStep2() {
                if (!this.uploadOrTake) {
                    this.isCameraOpen = true;
                    this.createCameraElement();
                }

                this.step = 7
            },
            createCameraElement() {
                const constraints = (window.constraints = {
                    audio: false,
                    video: true
                });

                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(stream => {
                        this.$refs.camera.srcObject = stream;
                    })
                    .catch(() => {
                        alert("May the browser didn't support or there is some errors.");
                    });
            },
            stopCameraStream() {
                let tracks = this.$refs.camera.srcObject.getTracks();

                tracks.forEach(track => {
                    track.stop();
                });
            },
            takePhoto() {
                this.isPhotoTaken = !this.isPhotoTaken;

                setTimeout(() => {
                    const context = this.$refs.canvas.getContext('2d');
                    context.drawImage(this.$refs.camera, 0, 0, 480, 270);
                }, 200)
            },
            submitPhoto() {
                let _ctrl = this;
                const canvas = document.getElementById('photoTaken');
                canvas.toBlob(function(blob) {
                    const formData = new FormData();
                    formData.append('file', blob, 'front.png');

                    _ctrl.$store.dispatch(AUser.UPLOAD_DOCUMENT_ONE, formData).then((res) => {
                        if (res.succeeded) {
                            _ctrl.stopCameraStream();
                            _ctrl.isPhotoTaken = false;

                            if (_ctrl.documnetId === 1) {
                                _ctrl.isCompleted = true
                                _ctrl.showDeclarativeData = false
                                _ctrl.$store.dispatch(AUser.UPLOAD_DOCUMENT_SUBMIT);
                            } else {
                                _ctrl.step = 6
                            }
                        }
                    })
                });
            },
            submitPhoto2() {
                let _ctrl = this;
                const canvas = document.getElementById('photoTaken');
                canvas.toBlob(function(blob) {
                    const formData = new FormData();
                    formData.append('file', blob, 'front.png');

                    _ctrl.$store.dispatch(AUser.UPLOAD_DOCUMENT_TWO, formData).then((res) => {
                        if (res.succeeded) {
                            _ctrl.stopCameraStream();
                            _ctrl.isCompleted = true
                            _ctrl.showDeclarativeData = false
                            _ctrl.$store.dispatch(AUser.UPLOAD_DOCUMENT_SUBMIT);
                        }
                    })
                });
            }
        },
        created() {
            this.$store.dispatch(AUser.GET_DECLARATIVE_DATA);

            this.vin_countries = Object.keys(this.countries);
            this.vin_countries.forEach((code) => {
                let allCountries = this.countries,
                    newCountry = {};
                newCountry.id = parseInt(allCountries[code].id);
                newCountry.code = code;
                newCountry.value = allCountries[code].value;
                this.countryMap.push(newCountry);
            })
        }
    }
</script>

<style scoped>
.btn-wrapper {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
}
.v-btn:not(.v-btn--round).v-size--default.retake-btn {
    display: flex;
    height: 51px;
    padding: 16px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    border-radius: 8px;
    border: 2px solid #004F7F;
    color: #004F7F;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.v-btn:not(.v-btn--round).v-size--default.submit-btn {
    display: flex;
    height: 51px;
    padding: 16px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    border-radius: 8px;
    background: #004F7F;
    color: #FFF;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.camera-box {
    height: 270px;
    width: 100%;
}
.camera-wrapper {
    height: 345px;
    width: 100%;
    margin: 32px auto;
    border-radius: 14px;
    background: #000;
    background-size: contain;
    border: 5px solid #000;
    position: relative;
}
.camera-wrapper-info {
    height: 60px;
    width: 100%;
    background: #E7E7E7;
    border-radius: 8px;
    position: absolute;
    bottom: 0;
    left: 0;
    align-items: center;
    display: flex;
    padding-left: 32px;
}
.camera-wrapper-info-text {
    color: #04010D;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
}
.dropzone-container {
    display: flex;
    border-radius: 8px;
    border: 2px dashed rgba(0, 0, 0, 0.38);
    height: 280px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    margin-bottom: 16px;
}
.dropzone-container-dragging {
    display: flex;
    border-radius: 8px;
    border: 2px dashed #004F7F;
    background: rgba(0, 79, 127, 0.1);
    height: 280px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    margin-bottom: 16px;
}
.upload-file-title {
    color: #04010D;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    text-align: center;
}
.upload-file-text {
    color: rgba(4, 1, 13, 0.60);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}
.file-label {
    font-size: 20px;
    display: block;
    cursor: pointer;
}
.preview-card {
    display: flex;
    width: 100%;
    height: 278px;
}

.preview-img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
}
.completed-wrapper {
    display: block;
    width: 375px;
    margin: 16px auto 108px;
}
.completed-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25px;
    align-self: stretch;
}
.completed-text {
    color: #04010D;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.completed-info {
    color: rgba(4, 1, 13, 0.60);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}
.completed-info2 {
    color: #04010D;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    margin-bottom: 32px;
}
.verify-wrapper {
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    position: relative;
}
.error-2fa {
    margin: 16px auto;
    color: #D5394F;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}
.main .sms-submit {
    height: 49px;
    margin-top: 55px;
    padding: 16px;
    width: 100%;
    border-radius: 8px;
    background: #004F7F;
    border: 0;
}
.main {
    width: 375px;
    margin: 32px auto 170px;
    justify-content: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 16px;
}
.sms-title {
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    align-self: stretch;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-top: 16px;
}
.sms-subtitle {
    color: rgba(4, 1, 13, 0.60);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 22px;
}
.sms-subtitle2 {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
}
.fieldset {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
}
.sms-digit {
    height: 48px;
    flex: 1 0 0;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.64);
    text-align: center;
    color: #004F7F;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.sms-digit-error {
    height: 48px;
    flex: 1 0 0;
    border-radius: 8px;
    border: 1px solid #ff0000;
    text-align: center;
    color: #ff0000;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.countdown {
    padding: 16px;
    margin-top: 16px;
    color: rgba(0, 0, 0, 0.38);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.countdown2 {
    padding: 16px;
    margin-top: 16px;
    color: #004F7F;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.countdown2:hover {
    cursor: pointer;
}
.upload-info {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    align-self: stretch;
    margin-bottom: 16px;
}
.upload-info-text {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px;
}
.v-btn:not(.v-btn--round).v-size--default.continue-upload-btn, .continue-upload-btn {
    display: flex;
    height: 51px;
    padding: 16px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #004F7F;
    width: 100%;
    color: #FFF;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    text-decoration: none;
}
.theme--light.v-btn.v-btn--disabled.continue-upload-btn {
    display: flex;
    height: 51px;
    padding: 16px 32px;
    justify-content: center;
    align-items: center;
    gap: 8px;
    align-self: stretch;
    border-radius: 8px;
    background: #D9D7DB;
    width: 100%;
    color: rgba(4, 1, 13, 0.4);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
}
.doc-country-wrapper {
    margin-bottom: 16px;
}
.tell-us-wrapper {
    padding-top: 172px;
    max-width: 1440px;
    width: 100%;
    margin: 0 auto;
    position: relative;
    z-index: 98;
}
.declarative-wrapper {
    border-radius: 16px;
    background: #F5F6F5;
    display: flex;
    width: 100%;
    max-width: 975px;
    padding: 24px;
    flex-direction: column;
    align-items: flex-start;
    margin: 0 auto 90px;
}
.declarative-title {
    color: #000;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.declarative-subtitle {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin-bottom: 32px;
}
.theme--light.v-btn.v-btn--has-bg.declarative-btn {
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    background: #004F7F;
    width: 224px;
    height: 36px;
}
.section-row {
    padding: 32px 0;
    position: relative;
    width: 100%;
    text-align: left;
}
.section-info {
    color: rgba(0, 0, 0, 0.88);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
}
.section-switch {
    position: absolute;
    right: 19px;
    top: 17px;
}
.country-select {
    height: 54px;
    padding: 0 12px;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.38);
}
.country-select:hover {
    cursor: pointer;
}
.doc-country-wrapper .country-select {
    height: 56px;
    padding: 16px;
    border: 0;
    color: #04010D;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px;
    border-radius: 16px;
}
.verify-modal {
    padding: 56px 40px 40px;
    border-radius: 16px;
    background: #F5F5F5;
}
.close-btn {
    height: 24px;
    width: 24px;
    position: absolute;
    top: 16px;
    right: 16px;
}
.back-modal-btn {
    height: 24px;
    width: 24px;
    position: absolute;
    top: 16px;
    left: 16px;
}
.close-btn:hover, .back-modal-btn:hover {
    cursor: pointer;
}
.verify-modal-title {
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 24px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}
.verify-modal-subtitle {
    color: rgba(0, 0, 0, 0.88);
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    margin: 16px auto;
}
.verify-modal-subtitle2 {
    color: #04010D;
    text-align: center;
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    margin-bottom: 16px;
}
.subtitle-wrapper {
    padding: 12px 0;
}
.subtitle-wrapper-text {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}
.doc-wrapper {
    display: flex;
    padding: 16px;
    flex-direction: row;
    gap: 16px;
    align-items: flex-start;
    align-self: stretch;
    border-radius: 16px;
    background: white;
    position: relative;
    margin-bottom: 8px;
}
.doc-wrapper2 {
    align-items: center;
    margin-bottom: 16px;
    height: 72px;
}
.upload-selection-wrapper {
    margin: 32px 0 16px;
}
.doc-wrapper2 .v-radio {
    justify-content: flex-end;
}
.doc-wrapper:hover {
    cursor: pointer;
}
.example-id1 {
    background: url('../assets/examples_id1.png') no-repeat center;
    width: 100%;
    height: 316px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id2 {
    background: url('../assets/example_id2.png') no-repeat center;
    width: 100%;
    height: 316px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id7 {
    background: url('../assets/example_id7.png') no-repeat center;
    width: 100%;
    height: 316px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id3 {
    background: url('../assets/example_id3.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id4 {
    background: url('../assets/example_id4.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id5 {
    background: url('../assets/example_id5.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id6 {
    background: url('../assets/example_id6.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id8 {
    background: url('../assets/example_id8.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id9 {
    background: url('../assets/example_id9.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id10 {
    background: url('../assets/example_id10.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id11 {
    background: url('../assets/example_id11.png') no-repeat center;
    width: 100%;
    height: 152px;
    background-size: contain;
    margin: 0 auto 16px;
}
.example-id3-wrapper {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    gap: 17.803px;
}
.doc-wrapper-img {
    background: url('../assets/ui_passport.png') no-repeat center;
    width: 40px;
    height: 40px;
    background-size: contain;
}
.doc-wrapper-img2 {
    background: url('../assets/ui_driver.png') no-repeat center;
    width: 40px;
    height: 40px;
    background-size: contain;
}
.doc-wrapper-img3 {
    background: url('../assets/ui_id2.png') no-repeat center;
    width: 40px;
    height: 40px;
    background-size: contain;
}
.doc-wrapper-img4 {
    background: url('../assets/ui_residence.png') no-repeat center;
    width: 40px;
    height: 40px;
    background-size: contain;
}
.doc-wrapper-text {
    color: #04010D;
    font-family: Montserrat, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 22px; /* 137.5% */
}
.doc-wrapper-info {
    color: rgba(4, 1, 13, 0.60);
    font-family: Montserrat, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 18px; /* 128.571% */
}
.doc-wrapper svg {
    position: absolute;
    top: 24px;
    right: 16px
}
</style>

<style>
    .how-it-works .header-toolbar {
        box-shadow: none;
    }
    .inner-page-app .hide-mobile {
        display: none;
    }
    .theme--light.v-btn.v-btn--has-bg.declarative-btn span {
        color: #FFF;
        font-family: Montserrat, sans-serif;
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        text-transform: none;
        letter-spacing: normal;
    }
    .declarative-wrapper .v-text-field--outlined > .v-input__control > .v-input__slot {
        background: #ffffff;
    }
    .declarative-wrapper .v-input input {
        max-height: 54px;
        border-bottom: 0;
    }
    .declarative-wrapper .v-text-field__details {
        display: none;
    }
    .declarative-select-wrapper .v-input input {
        max-height: 54px;
        height: 54px;
        border: 1px solid rgba(0, 0, 0, 0.38);
        padding: 0 12px;
        border-radius: 4px;
    }
    .declarative-select-wrapper .v-text-field {
        margin: 0;
        padding: 0;
    }
    .declarative-select-wrapper span {
        background: white;
        position: absolute;
        left: 11px;
        top: -5px;
        z-index: 2;
        color: rgba(0, 0, 0, 0.6);
        font-size: 12px;
        line-height: 11px;
        height: 11px;
    }
    .declarative-select-wrapper .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
        border: 0;
    }
    .declarative-wrapper .v-text-field.v-text-field--enclosed .v-text-field__details {
        margin-bottom: 0;
    }
    .declarative-wrapper .v-text-field.v-textarea {
        padding-top: 0;
    }
    .declarative-wrapper .v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 54px;
        margin-bottom: 0;
    }
    .verify-modal-wrapper {
        border-radius: 16px;
    }
</style>
